import React, { useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
} from "react-native";
//import FastImage from 'react-native-fast-image';
import { connect } from "react-redux";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import RupeeVal from "../../../commonComponents/RupeeVal";
import { no_internet } from "../../../utils/images";
import { SvgUri } from "react-native-svg";

const SocialMarketCard = ({ market }) => {
  return (
    <View
      style={[globalStyle.cardContainer, { backgroundColor: Colors.bgWhite }]}
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <View style={[styles.marketImgStyle, { marginRight: 12 }]}>
          <SvgUri width="30" height="30" uri={market.image_url} />
        </View>

        <Text
          style={[
            globalFontStyle.appFontSubTextWeight,
            { color: Colors.black, flex: 1 },
          ]}
          numberOfLines={2}
        >
          {market?.title}
        </Text>
      </View>

      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 16,
        }}
      >
        <RupeeVal rupeeVal={market?.volume} />

        <View style={styles.optionStyle}>
          <Text
            style={[globalFontStyle.appFontSmallText, { color: Colors.blue1 }]}
          >
            +{market?.options_count} options avaialble
          </Text>
        </View>
      </View>
    </View>
  );
};

export default SocialMarketCard;

const styles = StyleSheet.create({
  optionStyle: {
    paddingHorizontal: 10,
    paddingVertical: 7,
    borderWidth: 0.75,
    borderRadius: 20,
    borderColor: Colors.blue1,
  },
  marketImgStyle: {
    width: 35,
    height: 35,
  },
});
